import SubscribeForm from "../../SubscribeForm";
import { Typography } from "../../UI/Typography";
import LandingImage from "../../../assets/landing/Brian_v2.250420.png";
import LaptopImage from "../../../assets/landing/istockphoto-491910875-612x612.png";
import CalculatorImage from "../../../assets/landing/calculator.png";
import CoinsImage from "../../../assets/landing/coins.png";
import CatCalImage from "../../../assets/landing/Asset 9@4x.png";
import BackgroundImage from "../../../assets/landing/WelcomeBackground-1.png";

export const WelcomeSection = ({ onSubscribeSuccess }) => {
  return (
    <div
      className="px-3 max-w-[1450px] p-3 md:px-32 m-auto md:min-h-[600px] pt-32 lg:pt-10"
      // style={{ backgroundImage: "url(" + BackgroundImage + ")" }}
    >
      <div className="flex justify-center items-center flex-col lg:flex-row">
        <div className="main-section flex flex-col justify-start items-start lg:w-3/6">
          <div className="text-left">
            <h1 className="font-black uppercase text-red-prim text-6xl md:text-6xl">
              Get My
            </h1>
            <h1 className="font-black uppercase text-red-prim text-7xl md:text-7xl">
              Stock Value
            </h1>
            <h1 className="font-black uppercase text-red-prim mb-3 text-7xl md:text-7xl">
              Calculator
            </h1>
            <Typography variant="sub-title">
              Spending too much time evaluating value companies? 
              This automated
              spreadsheet based on the future free cash flow model will save you
              hundreds of hours. 
              And it can be delivered to your inbox for free!
            </Typography>
          </div>

          <div className="py-2"></div>
          <SubscribeForm content="I WANT IT" aligns="center" onSuccess={onSubscribeSuccess}/>
        </div>
        <div className="decor-right w-10/12 lg:w-6/12 relative pb-20">
          <img src={LandingImage} className="p-16" />
          <img
            src={LaptopImage}
            className="absolute top-[33%] left-2/4 w-6/12 animate-updown"
          />
          {/* <img
            src={CalculatorImage}
            className="absolute bottom-2/4 left-[90%] animate-tilt"
          />
          <img
            src={CoinsImage}
            className="absolute bottom-1/3 left-[100%] animate-tilt"
            style={{ animationDelay: "0.4s" }}
          />
          <img
            src={CatCalImage}
            className="absolute w-48 top-[90%] right-[40%] animate-updown"
            style={{ animationDelay: "0.4s" }}
          /> */}
        </div>
      </div>
    </div>
  );
};
